import { safeClone, ViewStream } from "spyne";
import { PageTraits } from "traits/page-traits";
import { BlogTraits } from "traits/blog-traits";
import sdk from "@stackblitz/sdk";
import PageTmplPricing from './templates/page-pricing.tmpl.html';
import {PageDocsItem} from 'components/pages/page-docs-item';
import {PricingItemView} from 'components/cards/pricing-item-view';
import {LocalStorageTraits} from 'traits/local-storage-traits';

export class PagePricing extends ViewStream {
  constructor(props = {}) {
    props.traits = PageTraits;
    props.data = safeClone(props.appData.pricing[0]);
    props.isBlog = true;
    props.class = "app-page";
    props.id = "l1-pricing";
   // props.data = props.appData?.pricing[0];
   //console.log('pricing data is ',props.data);
    //console.log('quick start page data ',props.appData);
    props.data.contentLen = PageTraits.page$GetContentLength(props.data);
    //props.template = require("./templates/page-docs.tmpl.html");
    props.template = PageTmplPricing;
    //props.template = require("./templates/page-quick-start.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
        ["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"]/*,
        ["CHANNEL_AUTH_AUTHENTICATION_EVENT", "onUserAuthenticated" ]*/
    ];
  }

  broadcastEvents() {
    // Declare only the pairs whose elements exist — unmatched selectors
    // warn at construction.
    const pairs = [
        ["button", "click"],
        ["a.plans__early-access", "click"],
        ['a.build-link', 'click']
    ];

    return pairs.filter(([sel]) => this.props.el$(sel).exists);
  }

  addIframe() {
    sdk.embedProjectId(
      this.props.el$(".docs-content").el,
      "send-info-to-channel",
      {
        openFile: "index.js",
      },
    );
  }

  onUserAuthenticated(e){
    const {payload} = e;
    const {userProfile} = payload;
    const {role} = userProfile;
    //console.log("USER AUTH ",e);

    if (this.props.authLoaded === false) {
      this.addPageDocItems(role)
    }


  }






  addPageDocItems(role="") {

    const addPageItems = (data) => {

    //console.log("DATA pricing IS ", role);
      this.appendView(new PricingItemView({ data, role }), ".pricing-container");
    };

    //this.props.data.content.forEach(addPageItems);
  }

  onRendered() {


    const userProfile = LocalStorageTraits.localStorage$GetUser();
    const role = userProfile?.role || 'new';


      this.addPageDocItems(role);


    // this.blog$CheckToAddBlogItems();
    this.addChannel("CHANNEL_APP_ROUTE", true);
    this.addChannel("CHANNEL_AUTH");
    this.page$InitPage();
    this.page$checkFor404();
    this.page$ScrollToTopOnLoad();


    //
    //this.addIframe();
    //this.appendView(new CodeGeneratorHolder(),  "#code-container");
    //this.appendView(new CodeContainerDetails(), "#code-container");
    //this.appendView(new CodePlaygroundView());
  }
}
